/**
 * Interactive Reading content type — EAA-1755.
 * TTS reading with synced word highlighting and optional pronunciation grading.
 */

import pkgJson from '../package.json';

export const VERSION = pkgJson.version;
export const PKG_NAME = pkgJson.name;

export {
    interactiveReadingSchema,
    defaultInteractiveReadingConfig,
    defaultInteractiveReadingData,
    defaultInteractiveReadingI18n,
    MAX_READING_TEXT_LENGTH,
    DEFAULT_READING_GRADING_QUESTION_TYPE,
    type InteractiveReadingContent,
    type InteractiveReadingData,
    type InteractiveReadingAnswer,
    type InteractiveReadingConfig,
    type InteractiveReadingScoringConfig,
    type ReadingStimulus,
    type ReadingWordTimestamp,
} from './schema';

export { InteractiveReadingEdit, type InteractiveReadingEditProps } from './InteractiveReadingEdit';

export {
    InteractiveReadingPlayer,
    type InteractiveReadingPlayerProps,
} from './InteractiveReadingPlayer';

export {
    interactiveReadingContentGrader,
    gradeInteractiveReading,
    countInteractiveReadingQuestions,
    interactiveReadingQuestionCounter,
} from './scorer';

export { interactiveReadingValidator } from './validator';

export { dataUrlToBlob, guessAudioExtension } from './utils';

export { interactiveReadingSchema as default } from './schema';
